import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/login/reload.png'


_pushScopeId("data-v-a9b98bb6")
const _hoisted_1 = { class: "dingtalk-login-container" }
const _hoisted_2 = {
  class: "qrcodeLoading",
  "element-loading-text": ""
}
const _hoisted_3 = {
  key: 0,
  class: "dingtalk-loading"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "dingtalk-loading-icon-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dingtalk-loading-icon" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "dingtalk-loading-text" }, "加载中...", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "dingtalk-error"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "加载失败", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "请检查网络连接", -1)
_popScopeId()

import { ref, onMounted, onBeforeUnmount, watch } from "vue";
import { checkPcTeachAuthorization } from "@/services";
import {
  getSchoolOAuthLoginConfig,
  createTeacherTokenByAuthCode,
} from "@/services/dingtalk";
import { ElMessage } from "element-plus";

import store, { MutationNames } from "@/store";
import config from "@/config/app.config";
import servers from "@/config/servers";
import useDingLogin from "@/hooks/useDingLogin";
import { useRouter } from "vue-router";
import logger from "@evideo/logger";


export default _defineComponent({
  props: {
  canShowErrorMessage: {
    type: Boolean,
    default: true,
  },
  school: {
    type: Object,
    default: null,
  },
},
  emits: ["handleLoginIn", "update:disable"] as unknown as undefined,
  setup(__props, { emit }: { emit: ({
  (event: "handleLoginIn", func: any): void;
  (event: "update:disable", func: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props



const router = useRouter();

const iframeSrc = ref();
let currentSchoolId = ref(0);
const showQrcode = ref(false);
const loginQrcodeRef = ref();
const qrcodeLoading = ref(false);

const showLoading = ref(false);
const showError = ref(false);

const { DTFrameLogin } = useDingLogin();
const removeDTFrameLoginMessageEvents = ref<any[]>([]);

const createLoginQrcode = async () => {
  const schoolId = props.school.schoolId;
  if (!schoolId) {
    router.push({
      path: "/chooseSchool",
    });
    return;
  }
  try {
    await initDingtalkQrcodeLogin(schoolId);
    // 学校权限校验
    const res: any = await checkSchoolAuth(schoolId);
    if (!res?.enable) {
      if (props.canShowErrorMessage) {
        ElMessage.error({
          message: res.message ?? "暂无权限",
        });
      }

      showQrcode.value = false;
      return;
    } else {
      showQrcode.value = true;
    }
  } catch (err) {
    console.error("创建钉钉二维码失败：", err);
    throw new Error("创建钉钉二维码失败");
  }
};

const checkSchoolAuth = async (schoolId: number) => {
  let mac = store.state.mac;
  if (mac === "0:0:0:0") {
    mac = mac + "-" + schoolId;
  }
  const res = await checkPcTeachAuthorization({
    school_id: schoolId,
    chip_id: mac,
  });
  return res;
};

const getRedirectUri = () => {
  return new Promise((resolve) => {
    // resolve(encodeURIComponent(`http://localhost:7071`));

    let redirectUri = encodeURIComponent(config[servers.dingtalkCallback]);
    const { ipcRenderer } = window.require("electron");
    if (ipcRenderer) {
      ipcRenderer
        .invoke("GET_IS_LOCAL_WEBSITE_ENABLE")
        .then((res: any) => {
          if (res.enable) {
            redirectUri = encodeURIComponent(
              `https://localhost:${res.mainWebViewServerPort}`
            );
          }
        })
        .catch((e: any) => {
          console.warn(e);
        })
        .finally(() => {
          resolve(redirectUri);
        });
    }
  });
};

const initDingtalkQrcodeLogin = async (schoolId: number) => {
  iframeSrc.value = null;
  currentSchoolId.value = schoolId;
  try {
    const res: any = await getSchoolOAuthLoginConfig(schoolId);
    const { oauth_login_js_params, oauth_login_url } = res.data;
    const redirectUri = await getRedirectUri();
    const dingLoginOpt = {
      redirect_uri: redirectUri,
      client_id: oauth_login_js_params.client_id,
      scope: oauth_login_js_params.scope,
      response_type: oauth_login_js_params.response_type,
      state: oauth_login_js_params.state,
      prompt: oauth_login_js_params.prompt,
    };
    console.log(111, dingLoginOpt);
    removeDTFrameLoginMessageEvents.value.forEach((remove) => remove());
    const removeDTFrameLoginEvent = DTFrameLogin(
      {
        id: "login-qrcode",
        width: 250,
        height: 250,
      },
      dingLoginOpt as any,
      async (loginResult: any) => {
        const { redirectUrl, authCode, state } = loginResult;
        if (store.state.dingtalkLoginState?.authCode === authCode) {
          if (store.state.dingtalkLoginState?.lock) {
            return;
          } else {
            store.commit(MutationNames.CHANGE_DINGTALKLOGINSTATE, {
              authCode,
              lock: true,
            });
          }
        } else {
          store.commit(MutationNames.CHANGE_DINGTALKLOGINSTATE, {
            authCode,
            lock: true,
          });
        }

        console.log(
          "钉钉登录执行",
          authCode,
          props.school.schoolId,
          store.state.dingtalkLoginState
        );
        emit("update:disable", true);
        try {
          const res: any = await createTeacherTokenByAuthCode({
            schoolId: props.school.schoolId,
            auth_code: authCode,
          });
          const teacherToken = res.data.access_token;

          emit("handleLoginIn", teacherToken);
        } catch (error) {
          ElMessage.error("无法登录");
          console.error(error);
          emit("update:disable", false);
        }
      },
      (errorMsg: any) => {
        console.error("钉钉登录失败");
        console.error(errorMsg);
        ElMessage.error({
          message: `钉钉登录失败:${errorMsg}`,
        });

        showQrcode.value = false;
      }
    );
    removeDTFrameLoginMessageEvents.value.push(removeDTFrameLoginEvent);
  } catch (err) {
    console.error("钉钉初始化失败", err);
  }
};
const reLoadDingtalkQrCode = async () => {
  logger.info("我点击重新加载钉钉二维码了");
  showError.value = false;
  showLoading.value = true;
  try {
    await createLoginQrcode();
  } catch (err: any) {
    console.error(err);
    showError.value = true;
    showLoading.value = false;
  }
  return;
};

watch(
  () => showQrcode.value,
  (v) => {
    if (v) {
      showError.value = false;
      showLoading.value = false;
      qrcodeLoading.value = true;
      setTimeout(() => {
        qrcodeLoading.value = false;
      }, 2000);
    } else {
      qrcodeLoading.value = false;
    }
  }
);

onMounted(async () => {
  showLoading.value = true;
  try {
    // 再次使用钉钉登录，使用本地存储中已选择的学校数据还原登录界面
    logger.info("初始化钉钉二维码中...");
    await createLoginQrcode();
    logger.info("初始化钉钉二维码成功");
  } catch (err) {
    logger.error("初始化钉钉二维码失败", err);
    showError.value = true;
  } finally {
    showLoading.value = false;
  }
});

onBeforeUnmount(() => {
  window.addEventListener("message", () => null);
  removeDTFrameLoginMessageEvents.value.forEach((remove) => remove());
});

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
        [_vShow, qrcodeLoading.value],
        [_directive_loading, qrcodeLoading.value]
      ]),
      _withDirectives(_createElementVNode("div", {
        ref: loginQrcodeRef,
        id: "login-qrcode",
        class: "login-qrcode"
      }, null, 512), [
        [_vShow, !qrcodeLoading.value]
      ])
    ], 512), [
      [_vShow, showQrcode.value]
    ]),
    (showLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
      : _createCommentVNode("", true),
    (showError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("img", {
            onClick: reLoadDingtalkQrCode,
            src: _imports_0,
            alt: ""
          }),
          _hoisted_8,
          _hoisted_9
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})